/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AlertKubernetesEventResponse,
  AlertMoveRequest,
  AlertRuleV9RequestBody,
  DeleteV9AlertAlertRulesParams,
  DeleteV9AlertAlertRulesReasonParams,
  GetV9AlertAlertRulesEventTypesParams,
  GetV9AlertAlertRulesParams,
  MetaAlertRuleListResponse,
  PatchV9AlertAlertRulesCloneByAlertRuleIdParams,
  PatchV9AlertAlertRulesMoveParams,
  PatchV9AlertAlertRulesReasonByEventIdParams,
  PatchV9AlertAlertRulesToggleParams,
  PostV9AlertAlertRulesReasonByKindParams,
  ResultResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 알람 룰 조회
 */
export const getV9AlertAlertRules = (
  params: MaybeRef<GetV9AlertAlertRulesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<MetaAlertRuleListResponse>(
    { url: `/api/v9/alert/alert-rules`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertAlertRulesQueryKey = (params?: MaybeRef<GetV9AlertAlertRulesParams>) => {
  return ['api', 'v9', 'alert', 'alert-rules', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertAlertRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertAlertRules>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertAlertRulesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertAlertRulesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertAlertRules>>> = ({ signal }) =>
    getV9AlertAlertRules(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertAlertRules>>,
    TError,
    TData
  >;
};

export type GetV9AlertAlertRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertAlertRules>>
>;
export type GetV9AlertAlertRulesQueryError = ErrorType<unknown>;

/**
 * @summary 알람 룰 조회
 */

export function useGetV9AlertAlertRules<
  TData = Awaited<ReturnType<typeof getV9AlertAlertRules>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertAlertRulesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertAlertRulesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 룰 추가
 */
export const postV9AlertAlertRules = (
  alertRuleV9RequestBody: MaybeRef<AlertRuleV9RequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleV9RequestBody = unref(alertRuleV9RequestBody);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v9/alert/alert-rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertRuleV9RequestBody,
      signal,
    },
    options,
  );
};

export const getPostV9AlertAlertRulesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertAlertRules>>,
    TError,
    { data: BodyType<AlertRuleV9RequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertAlertRules>>,
  TError,
  { data: BodyType<AlertRuleV9RequestBody> },
  TContext
> => {
  const mutationKey = ['postV9AlertAlertRules'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertAlertRules>>,
    { data: BodyType<AlertRuleV9RequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV9AlertAlertRules(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertAlertRulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertAlertRules>>
>;
export type PostV9AlertAlertRulesMutationBody = BodyType<AlertRuleV9RequestBody>;
export type PostV9AlertAlertRulesMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 추가
 */
export const usePostV9AlertAlertRules = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertAlertRules>>,
      TError,
      { data: BodyType<AlertRuleV9RequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertAlertRules>>,
  TError,
  { data: BodyType<AlertRuleV9RequestBody> },
  TContext
> => {
  const mutationOptions = getPostV9AlertAlertRulesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 룰 다중 삭제
 */
export const deleteV9AlertAlertRules = (
  params: MaybeRef<DeleteV9AlertAlertRulesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v9/alert/alert-rules`, method: 'DELETE', params: unref(params) },
    options,
  );
};

export const getDeleteV9AlertAlertRulesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV9AlertAlertRules>>,
    TError,
    { params: DeleteV9AlertAlertRulesParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV9AlertAlertRules>>,
  TError,
  { params: DeleteV9AlertAlertRulesParams },
  TContext
> => {
  const mutationKey = ['deleteV9AlertAlertRules'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV9AlertAlertRules>>,
    { params: DeleteV9AlertAlertRulesParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV9AlertAlertRules(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV9AlertAlertRulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV9AlertAlertRules>>
>;

export type DeleteV9AlertAlertRulesMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 다중 삭제
 */
export const useDeleteV9AlertAlertRules = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV9AlertAlertRules>>,
      TError,
      { params: DeleteV9AlertAlertRulesParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV9AlertAlertRules>>,
  TError,
  { params: DeleteV9AlertAlertRulesParams },
  TContext
> => {
  const mutationOptions = getDeleteV9AlertAlertRulesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Kubernetes 종류별 EVENT 조회
 */
export const getV9AlertAlertRulesEventTypes = (
  params: MaybeRef<GetV9AlertAlertRulesEventTypesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<string[]>(
    { url: `/api/v9/alert/alert-rules/eventTypes`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertAlertRulesEventTypesQueryKey = (
  params?: MaybeRef<GetV9AlertAlertRulesEventTypesParams>,
) => {
  return ['api', 'v9', 'alert', 'alert-rules', 'eventTypes', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertAlertRulesEventTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertAlertRulesEventTypesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertAlertRulesEventTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>> = ({
    signal,
  }) => getV9AlertAlertRulesEventTypes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>,
    TError,
    TData
  >;
};

export type GetV9AlertAlertRulesEventTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>
>;
export type GetV9AlertAlertRulesEventTypesQueryError = ErrorType<unknown>;

/**
 * @summary Kubernetes 종류별 EVENT 조회
 */

export function useGetV9AlertAlertRulesEventTypes<
  TData = Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertAlertRulesEventTypesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRulesEventTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertAlertRulesEventTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 룰 move
 */
export const patchV9AlertAlertRulesMove = (
  alertMoveRequest: MaybeRef<AlertMoveRequest[]>,
  params: MaybeRef<PatchV9AlertAlertRulesMoveParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  alertMoveRequest = unref(alertMoveRequest);
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v9/alert/alert-rules/move`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: alertMoveRequest,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV9AlertAlertRulesMoveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>,
    TError,
    { data: BodyType<AlertMoveRequest[]>; params: PatchV9AlertAlertRulesMoveParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>,
  TError,
  { data: BodyType<AlertMoveRequest[]>; params: PatchV9AlertAlertRulesMoveParams },
  TContext
> => {
  const mutationKey = ['patchV9AlertAlertRulesMove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>,
    { data: BodyType<AlertMoveRequest[]>; params: PatchV9AlertAlertRulesMoveParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV9AlertAlertRulesMove(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV9AlertAlertRulesMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>
>;
export type PatchV9AlertAlertRulesMoveMutationBody = BodyType<AlertMoveRequest[]>;
export type PatchV9AlertAlertRulesMoveMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 move
 */
export const usePatchV9AlertAlertRulesMove = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>,
      TError,
      { data: BodyType<AlertMoveRequest[]>; params: PatchV9AlertAlertRulesMoveParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesMove>>,
  TError,
  { data: BodyType<AlertMoveRequest[]>; params: PatchV9AlertAlertRulesMoveParams },
  TContext
> => {
  const mutationOptions = getPatchV9AlertAlertRulesMoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Kubernetes kind 별 reason 삭제
 */
export const deleteV9AlertAlertRulesReason = (
  params: MaybeRef<DeleteV9AlertAlertRulesReasonParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v9/alert/alert-rules/reason`, method: 'DELETE', params: unref(params) },
    options,
  );
};

export const getDeleteV9AlertAlertRulesReasonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>,
    TError,
    { params: DeleteV9AlertAlertRulesReasonParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>,
  TError,
  { params: DeleteV9AlertAlertRulesReasonParams },
  TContext
> => {
  const mutationKey = ['deleteV9AlertAlertRulesReason'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>,
    { params: DeleteV9AlertAlertRulesReasonParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV9AlertAlertRulesReason(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV9AlertAlertRulesReasonMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>
>;

export type DeleteV9AlertAlertRulesReasonMutationError = ErrorType<unknown>;

/**
 * @summary Kubernetes kind 별 reason 삭제
 */
export const useDeleteV9AlertAlertRulesReason = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>,
      TError,
      { params: DeleteV9AlertAlertRulesReasonParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV9AlertAlertRulesReason>>,
  TError,
  { params: DeleteV9AlertAlertRulesReasonParams },
  TContext
> => {
  const mutationOptions = getDeleteV9AlertAlertRulesReasonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 룰 toggle 수정
 */
export const patchV9AlertAlertRulesToggle = (
  params: MaybeRef<PatchV9AlertAlertRulesToggleParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v9/alert/alert-rules/toggle`, method: 'PATCH', params: unref(params) },
    options,
  );
};

export const getPatchV9AlertAlertRulesToggleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>,
    TError,
    { params: PatchV9AlertAlertRulesToggleParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>,
  TError,
  { params: PatchV9AlertAlertRulesToggleParams },
  TContext
> => {
  const mutationKey = ['patchV9AlertAlertRulesToggle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>,
    { params: PatchV9AlertAlertRulesToggleParams }
  > = (props) => {
    const { params } = props ?? {};

    return patchV9AlertAlertRulesToggle(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV9AlertAlertRulesToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>
>;

export type PatchV9AlertAlertRulesToggleMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 toggle 수정
 */
export const usePatchV9AlertAlertRulesToggle = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>,
      TError,
      { params: PatchV9AlertAlertRulesToggleParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesToggle>>,
  TError,
  { params: PatchV9AlertAlertRulesToggleParams },
  TContext
> => {
  const mutationOptions = getPatchV9AlertAlertRulesToggleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 룰 clone
 */
export const patchV9AlertAlertRulesCloneByAlertRuleId = (
  alertRuleId: MaybeRef<string>,
  params: MaybeRef<PatchV9AlertAlertRulesCloneByAlertRuleIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  alertRuleId = unref(alertRuleId);
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v9/alert/alert-rules/${alertRuleId}/clone`,
      method: 'PATCH',
      params: unref(params),
    },
    options,
  );
};

export const getPatchV9AlertAlertRulesCloneByAlertRuleIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>,
    TError,
    { alertRuleId: string; params: PatchV9AlertAlertRulesCloneByAlertRuleIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>,
  TError,
  { alertRuleId: string; params: PatchV9AlertAlertRulesCloneByAlertRuleIdParams },
  TContext
> => {
  const mutationKey = ['patchV9AlertAlertRulesCloneByAlertRuleId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>,
    { alertRuleId: string; params: PatchV9AlertAlertRulesCloneByAlertRuleIdParams }
  > = (props) => {
    const { alertRuleId, params } = props ?? {};

    return patchV9AlertAlertRulesCloneByAlertRuleId(alertRuleId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV9AlertAlertRulesCloneByAlertRuleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>
>;

export type PatchV9AlertAlertRulesCloneByAlertRuleIdMutationError = ErrorType<unknown>;

/**
 * @summary 알람 룰 clone
 */
export const usePatchV9AlertAlertRulesCloneByAlertRuleId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>,
      TError,
      { alertRuleId: string; params: PatchV9AlertAlertRulesCloneByAlertRuleIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesCloneByAlertRuleId>>,
  TError,
  { alertRuleId: string; params: PatchV9AlertAlertRulesCloneByAlertRuleIdParams },
  TContext
> => {
  const mutationOptions = getPatchV9AlertAlertRulesCloneByAlertRuleIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Kubernetes kind 별 reason 수정
 */
export const patchV9AlertAlertRulesReasonByEventId = (
  eventId: MaybeRef<number>,
  params: MaybeRef<PatchV9AlertAlertRulesReasonByEventIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  eventId = unref(eventId);
  params = unref(params);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v9/alert/alert-rules/${eventId}/reason`, method: 'PATCH', params: unref(params) },
    options,
  );
};

export const getPatchV9AlertAlertRulesReasonByEventIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>,
    TError,
    { eventId: number; params: PatchV9AlertAlertRulesReasonByEventIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>,
  TError,
  { eventId: number; params: PatchV9AlertAlertRulesReasonByEventIdParams },
  TContext
> => {
  const mutationKey = ['patchV9AlertAlertRulesReasonByEventId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>,
    { eventId: number; params: PatchV9AlertAlertRulesReasonByEventIdParams }
  > = (props) => {
    const { eventId, params } = props ?? {};

    return patchV9AlertAlertRulesReasonByEventId(eventId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV9AlertAlertRulesReasonByEventIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>
>;

export type PatchV9AlertAlertRulesReasonByEventIdMutationError = ErrorType<unknown>;

/**
 * @summary Kubernetes kind 별 reason 수정
 */
export const usePatchV9AlertAlertRulesReasonByEventId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>,
      TError,
      { eventId: number; params: PatchV9AlertAlertRulesReasonByEventIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV9AlertAlertRulesReasonByEventId>>,
  TError,
  { eventId: number; params: PatchV9AlertAlertRulesReasonByEventIdParams },
  TContext
> => {
  const mutationOptions = getPatchV9AlertAlertRulesReasonByEventIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Kubernetes 종류별 reason 조회
 */
export const getV9AlertAlertRulesReasonByKind = (
  kind: MaybeRef<
    | 'cronjob'
    | 'daemonset'
    | 'deployment'
    | 'hpa'
    | 'job'
    | 'node'
    | 'persistent_volume_claim'
    | 'pod'
    | 'replicaset'
    | 'service'
    | 'statefulset'
    | 'unknown'
  >,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kind = unref(kind);

  return customAxiosInstance<AlertKubernetesEventResponse>(
    { url: `/api/v9/alert/alert-rules/${kind}/reason`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertAlertRulesReasonByKindQueryKey = (
  kind?: MaybeRef<
    | 'cronjob'
    | 'daemonset'
    | 'deployment'
    | 'hpa'
    | 'job'
    | 'node'
    | 'persistent_volume_claim'
    | 'pod'
    | 'replicaset'
    | 'service'
    | 'statefulset'
    | 'unknown'
  >,
) => {
  return ['api', 'v9', 'alert', 'alert-rules', kind, 'reason'] as const;
};

export const getGetV9AlertAlertRulesReasonByKindQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>,
  TError = ErrorType<unknown>,
>(
  kind: MaybeRef<
    | 'cronjob'
    | 'daemonset'
    | 'deployment'
    | 'hpa'
    | 'job'
    | 'node'
    | 'persistent_volume_claim'
    | 'pod'
    | 'replicaset'
    | 'service'
    | 'statefulset'
    | 'unknown'
  >,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertAlertRulesReasonByKindQueryKey(kind);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>> = ({
    signal,
  }) => getV9AlertAlertRulesReasonByKind(kind, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(kind)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>, TError, TData>;
};

export type GetV9AlertAlertRulesReasonByKindQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>
>;
export type GetV9AlertAlertRulesReasonByKindQueryError = ErrorType<unknown>;

/**
 * @summary Kubernetes 종류별 reason 조회
 */

export function useGetV9AlertAlertRulesReasonByKind<
  TData = Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>,
  TError = ErrorType<unknown>,
>(
  kind: MaybeRef<
    | 'cronjob'
    | 'daemonset'
    | 'deployment'
    | 'hpa'
    | 'job'
    | 'node'
    | 'persistent_volume_claim'
    | 'pod'
    | 'replicaset'
    | 'service'
    | 'statefulset'
    | 'unknown'
  >,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertAlertRulesReasonByKind>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertAlertRulesReasonByKindQueryOptions(kind, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Kubernetes kind 별 reason 추가
 */
export const postV9AlertAlertRulesReasonByKind = (
  kind: MaybeRef<
    | 'cronjob'
    | 'daemonset'
    | 'deployment'
    | 'hpa'
    | 'job'
    | 'node'
    | 'persistent_volume_claim'
    | 'pod'
    | 'replicaset'
    | 'service'
    | 'statefulset'
    | 'unknown'
  >,
  params: MaybeRef<PostV9AlertAlertRulesReasonByKindParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  kind = unref(kind);
  params = unref(params);

  return customAxiosInstance<AlertKubernetesEventResponse>(
    {
      url: `/api/v9/alert/alert-rules/${kind}/reason`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV9AlertAlertRulesReasonByKindMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>,
    TError,
    {
      kind:
        | 'cronjob'
        | 'daemonset'
        | 'deployment'
        | 'hpa'
        | 'job'
        | 'node'
        | 'persistent_volume_claim'
        | 'pod'
        | 'replicaset'
        | 'service'
        | 'statefulset'
        | 'unknown';
      params: PostV9AlertAlertRulesReasonByKindParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>,
  TError,
  {
    kind:
      | 'cronjob'
      | 'daemonset'
      | 'deployment'
      | 'hpa'
      | 'job'
      | 'node'
      | 'persistent_volume_claim'
      | 'pod'
      | 'replicaset'
      | 'service'
      | 'statefulset'
      | 'unknown';
    params: PostV9AlertAlertRulesReasonByKindParams;
  },
  TContext
> => {
  const mutationKey = ['postV9AlertAlertRulesReasonByKind'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>,
    {
      kind:
        | 'cronjob'
        | 'daemonset'
        | 'deployment'
        | 'hpa'
        | 'job'
        | 'node'
        | 'persistent_volume_claim'
        | 'pod'
        | 'replicaset'
        | 'service'
        | 'statefulset'
        | 'unknown';
      params: PostV9AlertAlertRulesReasonByKindParams;
    }
  > = (props) => {
    const { kind, params } = props ?? {};

    return postV9AlertAlertRulesReasonByKind(kind, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertAlertRulesReasonByKindMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>
>;

export type PostV9AlertAlertRulesReasonByKindMutationError = ErrorType<unknown>;

/**
 * @summary Kubernetes kind 별 reason 추가
 */
export const usePostV9AlertAlertRulesReasonByKind = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>,
      TError,
      {
        kind:
          | 'cronjob'
          | 'daemonset'
          | 'deployment'
          | 'hpa'
          | 'job'
          | 'node'
          | 'persistent_volume_claim'
          | 'pod'
          | 'replicaset'
          | 'service'
          | 'statefulset'
          | 'unknown';
        params: PostV9AlertAlertRulesReasonByKindParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertAlertRulesReasonByKind>>,
  TError,
  {
    kind:
      | 'cronjob'
      | 'daemonset'
      | 'deployment'
      | 'hpa'
      | 'job'
      | 'node'
      | 'persistent_volume_claim'
      | 'pod'
      | 'replicaset'
      | 'service'
      | 'statefulset'
      | 'unknown';
    params: PostV9AlertAlertRulesReasonByKindParams;
  },
  TContext
> => {
  const mutationOptions = getPostV9AlertAlertRulesReasonByKindMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
